document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.c-tabs');

  const activateTab = (container, tabId) => {
    container.querySelectorAll('.tab-header-item, .c-tab').forEach((el) => el.classList.remove('tab--active'));

    const header = container.querySelector(`.tab-header-item[data-tab-id="${tabId}"]`);
    const content = container.querySelector(`.c-tab[data-tab-id="${tabId}"]`);

    if (header && content) {
      header.classList.add('tab--active');
      content.classList.add('tab--active');
    }
  };

  containers.forEach((container) => {
    const dropdown = container.querySelector('.tabs-dropdown');
    dropdown.addEventListener('change', (event) => {
      const tabId = event.target.value;
      activateTab(container, tabId);
      history.replaceState(null, '', `#${tabId}`);
    });
    // Click handling via delegation
    container.addEventListener('click', (e) => {
      const tab = e.target.closest('.tab-header-item');
      if (!tab) return;

      const tabId = tab.dataset.tabId;
      activateTab(container, tabId);
      history.replaceState(null, '', `#${tabId}`);
    });

    // Initial activation: use hash if present and valid for this container,
    // otherwise open the first tab inside this container by default.
    const hash = location.hash.slice(1);
    if (hash && hash.includes('tab-')) {
      // Only activate this container if it actually contains the requested tab id
      const hasTab = container.querySelector(`.tab-header-item[data-tab-id="${hash}"], .c-tab[data-tab-id="${hash}"]`);
      if (hasTab) {
        activateTab(container, hash);
        dropdown.value = hash;
      } else {
        // fall back to the container's first available tab
        const firstHeader = container.querySelector('.tab-header-item[data-tab-id]');
        if (firstHeader) {
          activateTab(container, firstHeader.dataset.tabId);
        } else {
          const firstContent = container.querySelector('.c-tab[data-tab-id]');
          if (firstContent) activateTab(container, firstContent.dataset.tabId);
        }
      }
    } else {
      // Prefer the first header tab; fall back to the first content tab if necessary
      const firstHeader = container.querySelector('.tab-header-item[data-tab-id]');
      if (firstHeader) {
        activateTab(container, firstHeader.dataset.tabId);
        dropdown.value = firstHeader.dataset.tabId;
      } else {
        const firstContent = container.querySelector('.c-tab[data-tab-id]');
        if (firstContent) activateTab(container, firstContent.dataset.tabId);
      }
    }
  });

  // React to hash changes
  window.addEventListener('hashchange', () => {
    const hash = location.hash.slice(1);
    if (!hash || !hash.includes('tab-')) return;

    // Only activate containers that actually contain the targeted tab id
    containers.forEach((container) => {
      const dropdown = container.querySelector('.tabs-dropdown');
      const hasTab = container.querySelector(`.tab-header-item[data-tab-id="${hash}"], .c-tab[data-tab-id="${hash}"]`);
      if (hasTab) {
        activateTab(container, hash);
        dropdown.value = hash;
      }
    });
  });
});
